/* eslint-disable @typescript-eslint/no-explicit-any */
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { ActionMenuItemCategoryEnum } from "./BaseActions";

export enum BaseActionEnum {


    Configure = "configure",
    Edit = "edit",
    CreateNew = "createNew",
    Duplicate = "duplicate",
    SetAsDefault = "setAsDefault",
    ModifyPermissions = "modifyPermissions",
    Delete = "delete",
    Rename = "rename",

    Copy = "copy",


    Refresh = 'refresh',
    Favorite = 'favorite',
    Export = 'export',
    Excel = 'excel',
    OnScreen = 'on-screen',
    PDF = 'pdf',
    Word = 'word',
    ExpandCollapse = 'expand-collapse',
    Options = 'options',


    DemandScan = 'demandscan',
    WriteDown = 'writedown',
    AddMemo = 'addmemo',
    AddRunTicket = 'addrunticket',
    SubmitWriteDown = 'submitwritedown',
    AddAttachment = 'addattachment',
    AddEvent = "addevent",
    AddDiagnositicEvent = 'adddiagnosticevent',
    AddWaterLossEvent = "addwaterlossevent",
    AddAttribute = 'addattribute',
    ShowDurationSettings = "showdurationsettings",
    ModifyPollingSchedule = 'modifypollingschedule',
    MapIt = 'mapit',
    DisableAllAlarms = 'disableallalarms',
    EnableAllAlarms = 'enableallalarms',
    ManageComm = 'managecomm',



    AddSetpoint = 'addsetpoint',
    ChangeRegister = 'changeregister',
    LinkToSetpoint = 'linksetpoint',
    ChangeTagType = 'changetagtype',
    CreateFormula = 'createformula',
    ChangeUom = 'changeuom',
    ChangeMasterIdentifier = 'changemasteridentifier',

    GoToWellDetails = 'gotowelldetails',
    ViewDashboard = 'viewdashboard',
    ViewWellHistory = 'viewwellhistory',
    HideWellHistory = 'hidewellhistory',

    MaximizeGraph = 'maxgraph',
    RestoreGraph = 'restoregraph',


    SaveGraphImage = 'savegraphimage',
    SaveQuickGraph = 'savequickgraph',

    ManageImages = 'manageimages',
    ManageMapFiles = 'managemapfiles',

    Run = 'run',
    SelectAll = 'selectall',
    RemoveAll = 'removeall',

    AddValue = 'addvalue',

    UserSettings = 'usersettings',
    ChangeCustomer = 'changecustomer',
    ContactSupport = 'contactsupport',
    SearchHelp = 'searchhelp',
    GetRemoteSupportCode = 'getremotesupportcode',
    RecentUpdates = 'recentupdates',
    SubmitProductIdea = 'supportproductidea',
    Version = 'version',
    HardwareOrder = 'hardwareorder',
    Terms = 'terms',
    PrivacyPolicy = 'privacypolicy',
    AppPreferences = 'appperferences',
    MenuVisibility = 'menuvisibility',
    MyProfile = 'myprofile',
    Signout = 'signout',
    OfflineMode = 'offlinemode',
    LastRefresh = 'lastrefresh',
    LastSync = 'lastsync',
    RefreshOfflineData = 'refreshofflinedata',

    Hide = 'hide',
    

    

    
}


export type BaseActions = 

BaseActionEnum.Edit |
BaseActionEnum.CreateNew |
BaseActionEnum.Duplicate |
BaseActionEnum.SetAsDefault |
BaseActionEnum.ModifyPermissions |
BaseActionEnum.Delete |
BaseActionEnum.Rename |
BaseActionEnum.Copy |

BaseActionEnum.Refresh | 
BaseActionEnum.Favorite | 
BaseActionEnum.Export | 
BaseActionEnum.Excel | 
BaseActionEnum.PDF | 
BaseActionEnum.ExpandCollapse |

BaseActionEnum.DemandScan |
BaseActionEnum.WriteDown |
BaseActionEnum.AddMemo |
BaseActionEnum.AddRunTicket |
BaseActionEnum.SubmitWriteDown |
BaseActionEnum.AddAttachment |
BaseActionEnum.AddEvent |
BaseActionEnum.AddDiagnositicEvent |
BaseActionEnum.AddWaterLossEvent |
BaseActionEnum.AddAttribute |
BaseActionEnum.ShowDurationSettings |
BaseActionEnum.ModifyPollingSchedule |
BaseActionEnum.MapIt |
BaseActionEnum.DisableAllAlarms |
BaseActionEnum.EnableAllAlarms |
BaseActionEnum.ManageComm |

BaseActionEnum.ChangeRegister | 
BaseActionEnum.AddSetpoint | 
BaseActionEnum.LinkToSetpoint | 
BaseActionEnum.ChangeTagType | 
BaseActionEnum.CreateFormula |
BaseActionEnum.ChangeUom |

BaseActionEnum.GoToWellDetails |
BaseActionEnum.ViewDashboard |
BaseActionEnum.ViewWellHistory |
BaseActionEnum.MaximizeGraph |
BaseActionEnum.RestoreGraph |
BaseActionEnum.HideWellHistory  |

BaseActionEnum.SaveGraphImage | 
BaseActionEnum.SaveQuickGraph |
BaseActionEnum.Run |
BaseActionEnum.SelectAll |
BaseActionEnum.RemoveAll |
BaseActionEnum.AddValue |

BaseActionEnum.UserSettings |
BaseActionEnum.ChangeCustomer |
BaseActionEnum.ContactSupport |
BaseActionEnum.SearchHelp |
BaseActionEnum.GetRemoteSupportCode |
BaseActionEnum.RecentUpdates |
BaseActionEnum.SubmitProductIdea |
BaseActionEnum.Version |
BaseActionEnum.HardwareOrder |
BaseActionEnum.Terms |
BaseActionEnum.PrivacyPolicy |
BaseActionEnum.AppPreferences |
BaseActionEnum.MenuVisibility |
BaseActionEnum.MyProfile |
BaseActionEnum.Signout |
BaseActionEnum.OfflineMode |
BaseActionEnum.LastRefresh |
BaseActionEnum.LastSync |
BaseActionEnum.RefreshOfflineData

;





// export type ActionMenuItem1 = {
//     label: string;
//     action: BaseActions;
//     icon?: any;
//     checkedIcon?: any;
//     disabled?: boolean;
//     checked?: boolean;
//     href?: string;
//     viewID?: UIViewEnum;
//     onClick?: () => void;
//     dividerBefore?: boolean;
//     dividerAfter?: boolean;
//     order?: number;
// };

export interface ActionMenuItem {
    label: string;
    helpText?: string;
    category?: ActionMenuItemCategoryEnum;
    //action: BaseActions;
    action?: string;
    icon?: any;
    checkedIcon?: any;
    disabled?: boolean;
    checked?: boolean;
    href?: string;
    viewID?: UIViewEnum;
    onClick?: () => void;
    dividerBefore?: boolean;
    dividerAfter?: boolean;
    order?: number;

    pulse?: boolean;

    id?: string;
    subActions? : ActionMenuItem[];
    color?: string;
    
    selected?: boolean;
};





